import React, { useEffect, useRef } from "react";
import { Animated, Text, TextProps } from "react-native";

interface AnimatedHeaderTextProps extends TextProps {
  children: React.ReactNode;
  shimmer?: boolean;
}

const AnimatedHeaderText: React.FC<AnimatedHeaderTextProps> = ({
  children,
  shimmer = false,
  style,
  ...rest
}) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 700,
      useNativeDriver: true,
    }).start();
  }, [fadeAnim]);

  // Optional: Add shimmer logic here if shimmer=true (future enhancement)

  return (
    <Animated.Text
      style={[
        { opacity: fadeAnim },
        style,
      ]}
      {...rest}
    >
      {children}
    </Animated.Text>
  );
};

export default AnimatedHeaderText;
